import { apiService } from './apiService';

export function getPagesService(data) {
    return apiService({
        method: 'POST',
        url: '/page/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdPagesService(id) {
    return apiService({
        method: 'GET',
        url: '/page/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getBySlugPagesService(slug) {
    return apiService({
        method: 'GET',
        url: '/page/by-slug/' + slug,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addPagesService(data) {
    return apiService({
        method: 'POST',
        url: '/page',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updatePagesService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/page/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deletePagesService(id) {
    return apiService({
        method: 'DELETE',
        url: '/page/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getTableBySlugPagesService(slug) {
    return apiService({
        method: 'GET',
        url: '/table/page/' + slug,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
